import Component from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/components/BottomTabBar.vue'
wx.createComponent(Component)